import { Backend } from '@dentalux/i18next-plugins';
import { Remarkable } from 'remarkable';
import RemarkableReactRenderer from 'remarkable-react';
const md = new Remarkable({
  linkTarget: '_blank'
});
md.renderer = new RemarkableReactRenderer();
const markdownRenderer = str => {
  return md.renderInline(str);
};
const markdownModule = {
  type: 'postProcessor',
  name: 'markdown',
  process: function (value) {
    return markdownRenderer(value);
  }
};
const markdownBlockModule = {
  type: 'postProcessor',
  name: 'markdownBlock',
  process: function (value) {
    return md.render(value);
  }
};
export default {
  reloadOnPrerender: true,
  i18n: {
    locales: ['en', 'de'],
    defaultLocale: 'de',
    backend: {
      applicationName: 'patient-account',
      strapiConfig: {}
    },
    ns: 'common'
  },
  debug: false,
  use: [Backend, markdownModule, markdownBlockModule],
  serializeConfig: false,
  react: {
    useSuspense: false
  }
};